function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.52 69.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,3.7c-6.28,4.28-6.29,2.67.13,25.24,3.88,13.64,4.13,15.28,4.16,27.75.03,12.58.13,13.25,2.03,13.23,2.84-.02,3.82-.95,5.78-5.48,2.18-5.05,3.36-11.57,4.16-23,1.07-15.34,1.61-19.4,3.11-23.64.8-2.26,1.45-5.22,1.45-6.58C25.52,5.42,19.25-.14,12.87,0c-1.57.03-5.24,1.7-8.17,3.69",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.98,4.32c1.13.74,2.69,2.53,3.47,3.98,1.24,2.31,1.18,3.28-.44,8.07-1.99,5.85-2.15,5.96-11.07,7.12l-5.09.66-1.66-5.92C1.74,9.54,1.95,8.48,6.77,5.05c4.52-3.21,8.09-3.43,12.21-.73",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07,36.19c-.37,6.19-1.12,13.85-1.66,17.03-1.08,6.32-4.31,14.72-5.67,14.72-.47,0-.5-2.99-.06-6.63.88-7.29-.08-15.79-3.07-27.18-1.39-5.31-1.6-7.42-.75-7.71,1.34-.45,6.06-1.11,9.53-1.33l2.36-.15-.67,11.25",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45);
export default __webpack_public_path__ + "static/media/45.187358e7a09c64fca351ff5afe0c3ed0.svg";
export { ForwardRef as ReactComponent };